// assets/custom-sticky-gallery.js (v2 - Using Correct Selectors)

/*
 * WHY: 動態計算頁面頂部固定元素 (如 Header, 公告列) 的總高度，
 *      並將其設定為 CSS 變數 --header-offset-height，
 *      供黏性定位的元素使用，以避免重疊。
 */
(function () {
  const calculateHeaderOffset = () => {
    // [FIX] 使用您找到的、佈景主題實際使用的 Class 名稱
    const header = document.querySelector('.header__wrapper');
    const announcementBar = document.querySelector('.announcement-bar');
    
    let offset = 0;

    // 檢查公告列是否存在且可見，如果可見則將其高度加入總偏移量
    if (announcementBar && getComputedStyle(announcementBar).display !== 'none') {
      offset += announcementBar.getBoundingClientRect().height;
    }
    
    // 檢查 Header 是否存在且可見，如果可見則將其高度加入總偏移量
    if (header && getComputedStyle(header).display !== 'none') {
      offset += header.getBoundingClientRect().height;
    }

    // 將計算出的總高度寫入 CSS 變數，供 CSS 檔案使用
    document.documentElement.style.setProperty('--header-offset-height', `${offset}px`);
  };

  // 在頁面載入、視窗大小改變、或 Shopify 區塊動態載入時，都重新計算一次高度
  window.addEventListener('load', calculateHeaderOffset);
  window.addEventListener('resize', calculateHeaderOffset);
  document.addEventListener('shopify:section:load', calculateHeaderOffset);
})();